import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

const interjections = {
    panda: {
        designer: 'dodizigi',
    },
    package: {
        designer: 'Martis Lupus',
    },
};

class FieldSetInterjection extends Component {
    static propTypes = {
        type: PropTypes.oneOf(Object.keys(interjections)).isRequired,
    };

    render() {
        let classes = classNames(
            'fieldset-interjection',
            `fieldset-interjection--${this.props.type}`
        );

        return (
            <div className={classes}>
                <img
                    className="fieldset-interjection__image"
                    src={require(`images/launch/interjection/${this.props.type}.png`)}
                />
                <div className="attribution">
                    <FormattedMessage
                        id="attribution"
                        values={{
                            designer: interjections[this.props.type]['designer'],
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default FieldSetInterjection;
